/*
 * @Author: your name
 * @Date: 2020-08-10 12:11:09
 * @LastEditTime: 2020-08-10 13:29:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/router/wechat.guard.js
 */
import router from './index'
import { weComSdkInit } from '@/vender/third-sdk/we-com-sdk'
import { isOnlyWeCom } from '@/lib/ui/utils/platform.util.js'

router.afterEach((to, from) => {
  if (isOnlyWeCom()) {
    weComSdkInit()
  }
})
